var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2352 6.13794C17.9222 3.93894 14.9751 0.25 10.0001 0.25C5.02511 0.25 2.07801 3.93894 0.765006 6.13794C0.0780059 7.28594 0.0780059 8.71306 0.765006 9.86206C2.07801 12.0611 5.02511 15.75 10.0001 15.75C14.9751 15.75 17.9222 12.0611 19.2352 9.86206C19.9222 8.71306 19.9222 7.28694 19.2352 6.13794ZM17.9481 9.09204C16.7981 11.018 14.2351 14.25 10.0001 14.25C5.76511 14.25 3.20212 11.019 2.05212 9.09204C1.65012 8.41804 1.65012 7.58098 2.05212 6.90698C3.20212 4.98098 5.76511 1.74902 10.0001 1.74902C14.2351 1.74902 16.7981 4.97998 17.9481 6.90698C18.3511 7.58198 18.3511 8.41804 17.9481 9.09204ZM10.0001 3.75C7.65611 3.75 5.75011 5.657 5.75011 8C5.75011 10.343 7.65611 12.25 10.0001 12.25C12.3441 12.25 14.2501 10.343 14.2501 8C14.2501 5.657 12.3441 3.75 10.0001 3.75ZM10.0001 10.75C8.48311 10.75 7.25011 9.517 7.25011 8C7.25011 6.483 8.48311 5.25 10.0001 5.25C11.5171 5.25 12.7501 6.483 12.7501 8C12.7501 9.517 11.5171 10.75 10.0001 10.75Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.32a72fb29bc0e1b0b8e561ca7a6c8068.svg";